import { ReactComponent as FiltersIcon } from './filters.svg';

export default FiltersIcon;
